import axios, { AxiosPromise } from 'axios';
import { ITumCredentials } from '../../../@types/model/masterData/tumCredentials/tumCredentials';
import { ITumCredentialsUpsert } from '../../../@types/model/masterData/tumCredentials/tumCredentialsUpsert';
import qs from 'qs';

export default class TumCredentialsHttpService {
    public static getList(organizationIds : Array<number>) : AxiosPromise<Array<ITumCredentials>> {
        return axios.get(`${API_URL}/v1/TumCredentials/GetAllWeb`, {
            params: {
                organizationIds,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static upsert(upsert : ITumCredentialsUpsert) : AxiosPromise<ITumCredentials> {
        return axios.post(`${API_URL}/v1/TumCredentials/Upsert`, upsert);
    }

    public static delete(id : number) : AxiosPromise<ITumCredentials> {
        return axios.delete(`${API_URL}/v1/TumCredentials/Delete`, {
            params: { id },
        });
    }
}
